<template>
  <div class="limited-time-rule-popup flex-center">
    <div class="rule-shadow" @click="hidePopup"></div>
    <div class="rule-popup">
      <p class="dialog-title">{{ letter.limitedTimeActivityRule }}</p>
      <div class="rule">
        <div class="rule-wrap" ref="limitedRuleWrap">
          <div class="rule-title-list">
            <div
              class="rule-title"
              :class="{ active: activeIndex === index }"
              v-for="(title, index) in rulesTitle"
              :key="index"
              :ref="index"
              @click="ruleClickHandle(index)"
            >
              {{ title }}
            </div>
          </div>
        </div>
        <div class="rule-desc" v-if="activityDesc[activeIndex]">
          <div v-html="activityDesc[activeIndex]"></div>
        </div>
        <div class="rule-text" v-html="rulesContent[activeIndex]"></div>
      </div>
      <Icon class="close-btn" name="close" @click="hidePopup"></Icon>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapState, mapGetters } from 'vuex';
import BScroll from 'better-scroll';
import bScrollSmartScroll from '@mixins/bScrollSmartScroll';
import {
  clickButton,
  popupType,
  showPopup
} from '@plugins/biPoint/_configWebstoreV35';
export default {
  name: 'limitedTimeRulePopup',
  mixins: [bScrollSmartScroll],
  props: ['timeAwardList', 'showRuleIndex'],
  data() {
    return {
      scroll: null,
      activeIndex: 0
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      gameId: state => state.gameId
    }),
    rulesTitle() {
      return this.timeAwardList.map(item => {
        return item?.basic?.title;
      });
    },
    rulesContent() {
      return this.timeAwardList.map(item => {
        return item?.basic?.rule;
      });
    },
    activityDesc() {
      return this.timeAwardList.map(item => {
        return item?.basic?.desc || '';
      });
    }
  },
  mounted() {
    this.activeIndex = this.showRuleIndex;
    this.initScroll();
    showPopup(popupType.eventsRulePopup);
  },
  methods: {
    ruleClickHandle(index) {
      this.activeIndex = index;
      // 点击后智能滚动
      const getItemRef = itemIndex => {
        const refArray = this.$refs[itemIndex];
        return Array.isArray(refArray) ? refArray[0] : refArray;
      };

      this.smartScrollToItem(
        index,
        'limitedRuleWrap',
        this.rulesTitle.length,
        getItemRef,
        {
          animationDuration: 300,
          edgeTolerance: 50,
          maxExposeWidth: 100,
          endMargin: 20
        }
      );
    },
    hidePopup() {
      this.$emit('onClose');
      clickButton({
        btnName: 'close_eventsrule',
        locationKey: popupType.eventsRulePopup
      });
    },
    initScroll() {
      this.scroll = new BScroll(this.$refs.limitedRuleWrap, {
        mouseWheel: true,
        scrollX: true,
        click: true
      });
      this.scroll.scrollToElement(this.$refs[this.activeIndex][0]);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/officialTopupNew.scss';
.limited-time-rule-popup {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 101;
  width: 100%;
  height: 100%;

  .rule-shadow {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }
  .rule-popup {
    position: relative;
    width: 720px;

    .dialog-title {
      z-index: 1;
      background-color: $backgroundColor;
      font-size: 24px;
    }
    .rule {
      background-color: $backgroundColor;
      padding: 0 40px 40px;
      border-radius: 0 0 20px 20px;
      font-size: 22px;
      margin-top: -1px;

      .rule-wrap {
        display: flex;
        align-items: start;
        overflow-x: hidden;
        margin-bottom: 40px;
        .rule-title-list {
          display: grid;
          grid-auto-flow: column;
          grid-auto-columns: max-content;
          gap: 20px;
          align-items: stretch;
          .rule-title {
            font-size: 22px;
            padding: 15px 20px;
            background-color: #e8e8e8;
            border-radius: 20px;
            border: solid 1px #e8e8e8;
            max-width: 233px;
            min-width: 127px;
            text-align: center;
            line-height: 1.2;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            &.active {
              background-color: #ffffff;
            }
          }
        }
      }
      .rule-text {
        white-space: pre-wrap;
        font-size: 20px;
        height: 341px;
        line-height: 1.5;
        overflow-y: scroll;
        &::-webkit-scrollbar {
          display: none;
        }
      }
      .rule-desc {
        font-size: 20px;
        margin-bottom: 20px;
      }
    }
  }

  .close-btn {
    position: absolute;
  }
}

#ssr-page.landscape {
  .limited-time-rule-popup {
    .rule-popup {
      .rule {
        .rule-text {
          font-size: 20px;
        }
      }
    }
  }
}
</style>
